import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateLayoutSegment } from 'redux/modules/embed/actions/layout';
import { showError } from 'redux/modules/notification';
import { Dispatch } from 'redux/types';
import { useEditSceneModalStateContext } from './state';
import useEditSceneModal from './useEditSceneModal';
import { createLayoutSegmentPatchFromState } from './utils';

export default function useSaveScene() {
  const reduxDispatch = useDispatch<Dispatch>();

  const { videoId, segmentId, onHide } = useEditSceneModal();

  const { dispatch: localDispatch, state } = useEditSceneModalStateContext();

  const handleSaveScene = useCallback(async () => {
    try {
      localDispatch({
        type: 'save-start',
      });

      await reduxDispatch(
        updateLayoutSegment(
          videoId,
          segmentId,
          createLayoutSegmentPatchFromState(state),
        ),
      );

      onHide();
    } catch (err) {
      reduxDispatch(showError({ message: 'Failed to save scene' }));
    } finally {
      localDispatch({
        type: 'save-end',
      });
    }
  }, [localDispatch, onHide, reduxDispatch, segmentId, state, videoId]);

  return { handleSaveScene };
}
